const isDisabled = process.env.VUE_APP_IS_ROUTE_DISABLED === "true";
export default {
  path: "/accounting",
  redirect: "/accounting/purchases",
  name: "AccountingIndex",
  component: () => import("@/components/PassThrough"),
  children: [
    {
      path: "",
      component: () => import("@/views/accounting/Accounts"),
      children: [
        {
          path: "expenses",
          name: "ExpenseIndex",
          components: {
            "accounting-view": () =>
              import("@/views/accounting/expenses/index"),
          },
          meta: {
            isDisabled: isDisabled,
            rule: "isPublic",
          },
        },
        {
          path: "purchases",
          name: "PurchasesIndex",
          components: {
            "accounting-view": () =>
              import("@/views/accounting/purchases/index"),
          },
          meta: {
            isDisabled: isDisabled,
            rule: "isPublic",
          },
        },
        {
          path: "sales",
          name: "SalesIndex",
          components: {
            "accounting-view": () => import("@/views/accounting/sales/index"),
          },
          meta: {
            rule: "isPublic",
            isDisabled: isDisabled,
          },
        },
      ],
      meta: {
        isDisabled: isDisabled,
      },
    },
    {
      path: "expense/create",
      name: "ExpenseForm",
      component: () => import("@/views/accounting/expenses/form"),
      meta: {
        rule: "isPublic",
        isDisabled: isDisabled,
      },
    },
    {
      path: "expense/:id",
      name: "ExpenseEditForm",
      component: () => import("@/views/accounting/expenses/form"),
      meta: {
        isDisabled: isDisabled,
        rule: "isPublic",
      },
    },
    {
      path: "sale/create",
      name: "SaleForm",
      component: () => import("@/views/accounting/sales/form"),
      meta: {
        isDisabled: isDisabled,
        rule: "isPublic",
      },
    },
    {
      path: "sale/:id",
      name: "SaleEditForm",
      component: () => import("@/views/accounting/sales/form"),
      meta: {
        isDisabled: isDisabled,
        rule: "isPublic",
      },
    },
    {
      path: "purchases/create",
      name: "PurchaseForm",
      component: () => import("@/views/accounting/purchases/PurchaseForm"),
      meta: {
        isDisabled: isDisabled,
        rule: "isPublic",
      },
    },
    {
      path: "purchases/:id",
      name: "PurchaseEditForm",
      component: () => import("@/views/accounting/purchases/PurchaseForm"),
      meta: {
        isDisabled: isDisabled,
        rule: "isPublic",
      },
    },
    {
      path: "purchases/chick/create",
      name: "ChickForm",
      component: () => import("@/views/accounting/purchases/ChickForm"),
      meta: {
        isDisabled: isDisabled,
        rule: "isPublic",
      },
    },
  ],
};
